export default {
  data() {
    return {
      hiddenFields: new Set(),
      customLoaded: false
    }
  },
  created() {
    this.loadInitControls()
  },
  methods: {
    loadInitControls() {
      var me = this
      var name = me.params && me.params.name
      var caller = me.params && me.params.caller
      if (!name || !caller) {
        me.customLoaded = true
        return
      }

      me.$ajax({
        url: '/api/ui/customize/init',
        params: {
          name: name,
          bizType: caller
        }
      }).then(function(res) {
        var initControls = res && res.data && res.data.properties && res.data.properties.initControls
        if (initControls) {
          me.hiddenFields = new Set(
            Object.keys(initControls).filter(function(key) {
              return initControls[key] === 1
            })
          )
        }
        me.customLoaded = true
      }).catch(function() {
        me.customLoaded = true
      })
    },
    isFieldHidden(path) {
      return this.hiddenFields.has(path)
    }
  }
}